import React from 'react';

const ContactForm = () => {
    const handleSubmit = (e) => {
        e.preventDefault();
        const formData = new FormData(e.target);

        fetch("https://docs.google.com/forms/d/e/1FAIpQLSdJ98iYLELTPOhvFJCC0qslkE8wlfyO0_AAmEvCUVYybksPrw/formResponse", {
            method: "POST",
            body: formData,
            mode: "no-cors", // Prevent CORS issues
        }).then(() => {
            alert("Form submitted successfully!");
        }).catch(() => {
            alert("There was an error submitting the form.");
        });
    };

    return (
        <form onSubmit={handleSubmit}>
            <input type="text" name="entry.448084769" placeholder="Your Name" required />
            <input type="email" name="entry.415270262" placeholder="Your Email" required />
            <input type="hidden" className="hidden_field" name="entry.438292009" placeholder="hidden_field"  />
            <textarea name="entry.69519196" placeholder="Your Message" required />
            <button type="submit">Send</button>
        </form>
    );
};

export default ContactForm;